/**
 * <s-country-filter> — filters the localization country list as the shopper types.
 *
 * Matches against each row's `data-country-name` (country name, ISO code and currency code),
 * so "aus", "AU" and "AUD" all find Australia. Shows `[data-country-empty]` when nothing matches.
 * Enter in the search field picks the first visible country.
 */
class SCountryFilter extends HTMLElement {
  #ac = null;

  connectedCallback() {
    const input = this.querySelector('[data-country-search]');
    if (!input) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    input.addEventListener('input', () => this.#filter(input.value), { signal });
    input.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        const first = this.#rows().find((row) => !row.hidden);
        first?.querySelector('button')?.click();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #rows() {
    return Array.from(this.querySelectorAll('li[data-country-name]'));
  }

  #filter(value) {
    const query = value.trim().toLowerCase();
    let visible = 0;
    for (const row of this.#rows()) {
      const match = !query || (row.dataset.countryName || '').includes(query);
      row.hidden = !match;
      if (match) visible += 1;
    }
    const empty = this.querySelector('[data-country-empty]');
    if (empty) empty.classList.toggle('hidden', visible > 0);
  }
}

if (!customElements.get('s-country-filter')) {
  customElements.define('s-country-filter', SCountryFilter);
}
